import React from 'react';
import moment from 'moment';
import HoverTooltip from './HoverTooltip';
import dateFormats from 'helpers/dateFormats';

interface Props {
    dateTime: Date;

    floatRight?: boolean;
    displayExactTimePopup?: boolean;
}

const RelativeTime: React.FC<Props> = ({ dateTime, floatRight = true, displayExactTimePopup = true }: Props) => {
    return displayExactTimePopup ? (
        <span className={`relative group ${floatRight ? 'float-right' : ''}`}>
            <HoverTooltip
                content={
                    <div className="p-1 font-semibold ">
                        <div className=" text-white  ">{moment(dateTime).format(dateFormats.USA_DATETIME)}</div>
                        {/* <div className="-ml-1 inline-block  w-3 h-3 mt-2 transform rotate-45 bg-blue-800"></div> */}
                    </div>
                }
            >
                {moment(dateTime).fromNow()}
            </HoverTooltip>
        </span>
    ) : (
        <span>{moment(dateTime).fromNow()}</span>
    );
};

export default RelativeTime;
